// extracted by mini-css-extract-plugin
export var onoffswitch = "pricing-module--onoffswitch--7R20P";
export var onoffswitch_checkbox = "pricing-module--onoffswitch_checkbox--28Ojl";
export var onoffswitch_label = "pricing-module--onoffswitch_label--2ocU7";